const COUNTRY_CODES: Record<string, string> = {
  Armenia: "AM", Australia: "AU", Brazil: "BR", Canada: "CA", Colombia: "CO",
  France: "FR", Germany: "DE", Greece: "GR", India: "IN", Indonesia: "ID",
  Japan: "JP", Mexico: "MX", Norway: "NO", Philippines: "PH", "South Africa": "ZA",
  "United Kingdom": "GB", "United States": "US",
};

export const countryFlag = (country?: string): string => {
  if (!country) return "";
  const code = COUNTRY_CODES[country];
  return code ? String.fromCodePoint(...code.split("").map((char) => 127397 + char.charCodeAt(0))) : "🌍";
};
